<div class="user-sidebar">
    <img src="/assets/images/lines.svg" alt="" class="lines-up">
    <img src="/assets/images/lines.svg" alt="" class="lines-down">
    <div class="row m-px-0" *ngIf="sidebarS.vista=='widgets'">
        <h3 class=" main-title">Santa Maria del Salitre</h3>
        <div class="col-12">
            <div class="card balance">
                <div class="date centrado-v">
                    13-09-2021
                </div>
                <div class="ammount">
                    $120,000.00
                </div>
                <img src="/assets/images/circle-lines.svg" alt="" class="bg">
            </div>
        </div>
        <div class="col-5">
            <div class="card locker">
                <h4 class="title">
                    Mi casillero virtual
                </h4>
                <div class="row">
                    <div class="col-6">
                        <div class="item">
                            <div class="circle">
                                <app-feather-icons icon="droplet"></app-feather-icons>
                            </div>
                        </div>
                        <div class="text">
                            Agua
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="item active">
                            <div class="circle">
                                <app-feather-icons icon="droplet"></app-feather-icons>
                            </div>
                        </div>
                        <div class="text">
                            Gas
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="item active">
                            <div class="circle">
                                <app-feather-icons icon="droplet"></app-feather-icons>
                            </div>
                        </div>
                        <div class="text">
                            Luz
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="item">
                            <div class="circle">
                                <app-feather-icons icon="droplet"></app-feather-icons>
                            </div>
                        </div>
                        <div class="text">
                            Paquetes
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="item">
                            <div class="circle">
                                <app-feather-icons icon="droplet"></app-feather-icons>
                            </div>
                        </div>
                        <div class="text">
                            Administracion
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="item active">
                            <div class="circle">
                                <app-feather-icons icon="droplet"></app-feather-icons>
                            </div>
                        </div>
                        <div class="text">
                            Aseo
                        </div>
                    </div>
                </div>
                <div class="end"></div>
            </div>
        </div>
        <div class="col-7 comun">
            <div class="card title">
                <app-feather-icons icon="flag"></app-feather-icons>
                <h3 class="title-text">
                    Zonas comunes
                </h3>
            </div>
            <div class="card item">
                BBQ
                <ng-toggle [attr.value]="false" [attr.color]="{
                unchecked: '#939da2',
                checked: '#87787f'
                }"></ng-toggle>
            </div>
            <div class="card item">
                Zona de Juegos
                <ng-toggle [attr.value]="false" [attr.color]="{
                unchecked: '#939da2',
                checked: '#87787f'
                }"></ng-toggle>
            </div>
            <div class="card item">
                Gimnacio
                <ng-toggle [attr.value]="false" [attr.color]="{
                unchecked: '#939da2',
                checked: '#87787f'
                }"></ng-toggle>
            </div>
            <div class="card item">
                Sauna
                <ng-toggle [attr.value]="false" [attr.color]="{
                unchecked: '#939da2',
                checked: '#87787f'
                }"></ng-toggle>
            </div>
        </div>
    </div>
    <div *ngIf="sidebarS.vista=='erp'">
        <div class="row m-px-0">

            <div class="col-6 m-px-b-15">
                <button class="modules centrado-h" [class.active]="selected=='monitores'" (click)="selected='monitores'">
                    Monitores
                </button>
            </div>
            <div class="col-6 m-px-b-15">
                <button class="modules centrado-h" [class.active]="selected=='reportes'" (click)="selected='reportes'">
                    Reportes
                </button>
            </div>
            <div class="col-6 m-px-b-15">
                <button class="modules centrado-h" [class.active]="selected=='procesos'" (click)="selected='procesos'">
                    Procesos
                </button>
            </div>
            <div class="col-6 m-px-b-15">
                <button class="modules centrado-h" [class.active]="selected=='parametros'" (click)="selected='parametros'">
                    Parametros
                </button>
            </div>
            <div class="col-3 m-px-b-15">
                <select class="form-control form-control-lg" [(ngModel)]="ano">
                    <option *ngFor="let i of iterano" [value]="2022 - i">
                        {{ 2022 - i }}
                    </option>
                </select>
            </div>
            <div class="col-3 m-px-b-15">
                <select class="form-control form-control-lg" [(ngModel)]="periodo">
                    <option *ngFor="let i of itermes" [value]="i">
                        {{ i }}
                    </option>
                </select>
            </div>
            <div class="col-6 m-px-b-15">
                <div class="search">
                    <input type="text" [(ngModel)]="search" (input)="filterPersonas()">
                </div>
            </div>
        </div>
        <div class="row m-px-0 scrollable-part" *ngIf="selected!='parametros'">
            <div class="col-4 p-px-20" *ngFor="let modulo of menu[selected]" >
                <div class="modulo-desc" (click)="trigger(selected,modulo)">
                    <!-- <img src="/assets/icons/module.svg" alt="" class="icon centrado-h"> -->
                    <!-- <svg class="icon centrado-h"  style="fill: #8778F7;">
                        <use xlink:href="/assets/icons/law.svg#law"></use>
                    </svg> -->
                    <svg-icon svgClass="icon centrado-h" [src]="modulo.icon" [svgStyle]="{fill:'#8778F7'}"></svg-icon>
                    <h3 class="title">{{modulo.text}}</h3>
                    <div class="user-mark" *ngIf="modulo.per">U</div>
                </div>
            </div>
        </div>
        <div class="row m-px-0 o-y-scroll scrollable-part" *ngIf="selected=='parametros' && erpS.loaded">
            <select class="form-control form-control-lg" [(ngModel)]="moduloSel">
                <option [value]="0">
                    {{ erpS.modulos[0].nom_obj }}
                </option>
                <option [value]="1">
                    {{ erpS.modulos[1].nom_obj }}
                </option>
                <option [value]="2">
                    {{ erpS.modulos[2].nom_obj }}
                </option>
                <option [value]="3">
                    {{ erpS.modulos[3].nom_obj }}
                </option>
                <option [value]="4">
                    {{ erpS.modulos[4].nom_obj }}
                </option>
                <option [value]="10">
                    {{ erpS.modulos[10].nom_obj }}
                </option>
                <option [value]="12">
                    {{ erpS.modulos[12].nom_obj }}
                </option>
                <option [value]="22">
                    {{ erpS.modulos[22].nom_obj }}
                </option>
            </select>
            <div class="col-4 p-px-20" *ngFor="let modulo of erpS.modulos[moduloSel].modulos | keyvalue">
                <div class="modulo-desc" (click)="trigger(selected,modulo.value)">
                    <svg-icon svgClass="icon centrado-h" [src]="modulo.value.icon" [svgStyle]="{fill:'#8778F7'}"></svg-icon>
                    <!-- <img src="/assets/icons/module.svg" alt="" class="icon centrado-h"> -->
                    <h3 class="title">{{modulo.value.nom_obj}}</h3>
                    <div class="user-mark" *ngIf="modulo.value.per">U</div>
                </div>
            </div>
        </div>
    </div>
    <div class="m-px-0" *ngIf="sidebarS.vista=='formulario'">
        <div *ngIf="!loadingForm" [innerHtml]="linkseditseg">
        </div>
           <h2 class="title m-px-b-20">
                {{titleForm}}
            </h2>
            <h4 class="loading text-center" *ngIf="loadingForm">
                Cargando Formulario...
            </h4>
            <div class="alert alert-danger" *ngIf="!loadingForm && error && texterror">
                <ul>
                    <li *ngFor="let regerror of texterror">
                        {{regerror.menerror}}
                    </li>
                </ul>
            </div>
            
        <div id="cont" [innerHtml]="htmlForm" *ngIf="!loadingForm" (click)="processLinks($event)"></div>
        <!-- <button class="btn btn-danger cancel" (click)="goBack()" *ngIf="!loadingForm">
            Cancelar
        </button> -->
    </div>
    <div class="m-px-0" *ngIf="sidebarS.vista=='documento'">
        <div *ngIf="!loadingForm" [innerHtml]="linkseditseg">
        </div>
           <h2 class="title m-px-b-20">
                {{titleForm}}
            </h2>
            <h4 class="loading text-center" *ngIf="loadingForm">
                Ponga filtro
            </h4>
            <div class="row">
                <div class="col-4">
                    documento 1
                </div>
                <div class="col-4">
                    <button class="btn btn-primary"  (click)="documentoMsg(0,1)">
                        modificar
                    </button>
                </div>
                <div class="col-4">
                    <button class="btn btn-primary" (click)="documentoMsg(1,1)">
                        eliminar
                    </button>
                </div>
                <div class="col-4">
                    documento 2
                </div>
                <div class="col-4">
                    <button class="btn btn-primary"  (click)="documentoMsg(0,1)">
                        modificar
                    </button>
                </div>
                <div class="col-4">
                    <button class="btn btn-primary" (click)="documentoMsg(1,1)">
                        eliminar
                    </button>
                </div>
            </div>
            
        <div id="cont" [innerHtml]="htmlForm" *ngIf="!loadingForm" (click)="processLinks($event)"></div>
        <!-- <button class="btn btn-danger cancel" (click)="goBack()" *ngIf="!loadingForm">
            Cancelar
        </button> -->
    </div>

</div>